/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import { makeSideBarActive } from '../../utils/EllowUtils';
import * as CONSTANTS from '../../utils/CONSTANTS'
import { useNavigate } from 'react-router-dom';
import ApplyPositions from "./applyPositions";
import { getAPI } from "../../api";
import { applyCandidateToJob, getAllocatedto} from './services';
import { REACT_APP_JOB } from '../../utils/common';
import NotificationAlert from "../../components/notification";
import { getCandidates } from './services';
import mixpanelData from '../../utils/mixpanel';


function Applypositions() {

  const navigate = useNavigate()
  const location = useLocation();
  const { jobId }: any = location.state || ''
  const {companyName}:any = location.state || ''
  const loginId = localStorage.getItem('loginId')
  const customerId = localStorage.getItem('customerId')
 


  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1)
  const [jobMetadata, setJobMetadata] = useState<{
    resources: number , experienceRange: number , title: string, contractDuration : string , startDate: number , minimumBudget: number , maximumBudget: number ,
    billingType: string ,jobRole: {id: number, name: string} , coreSkills:[{skillId: number, skillName: string}] , otherSkills: [{skillId: number, skillName: string}]
  }>()
  const [resources, setResources] = useState<any>()
  const [total, setTotal] = useState<number>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [coreSkills, setCoreSkills] = useState<any>([])
  const [jobExperience, setJobExperience] = useState<any>({})
  const [filterValues, setFiltervalues] = useState<any>({})
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [rateInMail, setRateInMail] = useState(false)

  let BreadcrumsValues = ['Positions', jobMetadata?.title]
  
  useEffect(() => {
    getAPI( REACT_APP_JOB + `/position/${jobId}`).then(
      (response) => { 
        if (response && response.status === 1) {
          setJobMetadata(response.data[0].job_metadata)
          setRateInMail(response.data[0].showRateInEmail)

    let skills = response.data[0] && response.data[0].job_metadata && response.data[0].job_metadata.coreSkills.map((item: any) => {
      return item.skillName
    })
          setCoreSkills(skills)
          setJobExperience(response.data[0].job_metadata.experienceRange)
          getAllCandidates(25, 1, '', skills, response.data[0].job_metadata.experienceRange)
  
          let experience = {
            from: response.data[0].job_metadata.experienceRange.min,
            to: response.data[0].job_metadata.experienceRange.max
     }
          setFiltervalues({core_skills: skills, experience: experience})
        }
      }
    );
    getAllocation();
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId])
  


  const getAllocation = () => {
    getAllocatedto().then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };

  const getPageChange = (pageSize: any, pageNumber: number) => {

      let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;
      getAllCandidates(pageSize, page, '' , "",'','')
  }

  const getAllCandidates = (pageSize: number, pageNumber: number, searchValue: string, skills?: any, experienceRange?: any, filters?: any) => { 

    let body ={}
    if (filters) {
      filters.resourcesToExcludeForJobId = jobId
      filters.inContract = false
      filters.loginId = loginId
      filters.behalf_of = {
        id: customerId,
        name: ''
      }

      body = {
         filters
      }
    }

    else {        
      body = {
        filters: {
          inContract: false,
          loginId: loginId,
          resourcesToExcludeForJobIdProvider: jobId,
          behalf_of: {
            id: customerId,
            name: ''
          }
        }
      }
    }  

     
    getCandidates( 'allResources', pageSize, pageNumber, searchValue, body).then((resp) => {
      if( resp && resp.status === 1){
        setResources(resp.data) 
        setTotal(resp.count)
      }
    })
  }

  const searchChange = (e: string) => {
    
    getAllCandidates(25, 1, e, coreSkills, jobExperience)

  }

  const onSubmit = (data: any) => {

    const loginIds = data && data.length > 0 && data.map((item: any) => {
      return (
        item.loginId
      )
    } )

    let body = {
      userLoginId: loginId,
      jobId: jobId,
      loginId: loginIds
    }

    applyCandidateToJob(body).then((response) => {
      if (response && response.status === 1) {
        loginIds && loginIds.length > 0 && loginIds.map((item: any, key: number) => {
          mixpanelData('New ML - Candidate applied', {
            'distinct_id': localStorage.getItem('Email') ,
            'Candidate name': response && response.data.candidateDetails[key].CandidateName,
            'Candidate email': response && response.data.candidateDetails[key].candidateEmail,
            'Phone number': response && response.data.candidateDetails[key].phoneNumber,
            'Experience': response && response.data.candidateDetails[key].experience + ' Years',
            'Job role': response && response.data.jobDetails[0].JobRole.name,
            'Expected pay': response && response.data.candidateDetails[key].expectedPay + ' ' + response.data.candidateDetails[key].currencyType + '/' + response.data.candidateDetails[key].billingType,
            'Submitted by': response && response.data.candidateDetails[key].submittedUserName,
            'JobId': response && response.data.jobDetails[0].jobId,
            'Job type': response && response.data.jobDetails[0].jobType,
            'Position name': response && response.data.jobDetails[0].position,
            'Company name': response && response.data.jobDetails[0].companyName,
            'Candidate loginid': item
        })
        })
        displayNotification()
        mixpanelData('ML- Apply candidate to Job', {
          'source': 'Provider applies a candidate to Job',
          'distinct_id': localStorage.getItem('Email'),
          'Position name': jobMetadata?.title,
          'contractDuration': jobMetadata?.contractDuration,
          'startDate': jobMetadata?.startDate,
          'minimumBudget': jobMetadata?.minimumBudget,
          'maximumBudget': jobMetadata?.maximumBudget,
          'experienceRange': jobMetadata?.experienceRange,
          'JobRole': jobMetadata?.jobRole?.name,
          'Skills': jobMetadata?.coreSkills && jobMetadata.coreSkills.length > 0 && jobMetadata.coreSkills.map((item: any) => item.skillName),
          'Other Skills': jobMetadata?.otherSkills && jobMetadata.otherSkills.length > 0 && jobMetadata.otherSkills.map((item: any) => item.skillName)

        })
      }
    })

  }

  const displayNotification = () => {
    setMessage('Profile is shared with ellow team.')
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      navigate('/position-details',{ state: { jobId: jobId, positionName:jobMetadata?.title, companyName:companyName }})
     }, 3000)  
  }

  const onClose = () => {
    setNotification(false)
  }
 
  const closeTag = (data: any) => {
    if (!data.experience) {
      setJobExperience(undefined)
    }
    setFiltervalues(data)
    getAllCandidates(25, 1, '', '', '', data)
  }

  const applyFilter = (data: any) => {
    
    if (data.availability) {
      data.availability = data.availability.value
    }

    if (data.minimumBudget === '') {
      delete data.minimumBudget
    }
    setFiltervalues(data)
    getAllCandidates(25, 1, '', '', '', data)
    
  }
  

  return (
    <section className="dashboardWrapper">
      {notification && <NotificationAlert onClose={onClose } closable={true} >
        {message}
      </NotificationAlert> }
      <SideMenu menu={menu}/>
      <div className="dashboardContent">
        <DashboardHeader title={BreadcrumsValues} navigateTo="" searchChange={''} />
        <ApplyPositions jobMetadata={jobMetadata} onSubmit={onSubmit} data={resources} total={total} pageSize={getPageChange} jobId={jobId} searchChange={searchChange} filtervalues={filterValues} closeTag={closeTag} allocatedTo={allocatedTo} applyFilter={applyFilter} rateInMail={rateInMail} />        
      </div>
    </section>
  )
}

export default Applypositions